const baseUrl = process.env.REACT_APP_PROXY_SERVER_URL || '';
const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

export const getApiUrlWithPath = (apiPath: string): string => {
  // Prevent misuse with absolute URLs
  if (apiPath.match(/^https?:\/\//)) {
    throw new Error('getApiUrlWithPath should not be called with absolute URLs');
  }

  const normalizedPath = apiPath.startsWith('/') ? apiPath : `/${apiPath}`;

  return normalizedBaseUrl + normalizedPath;
};
